import { useTranslation } from "react-i18next";
import React, { memo, useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useAxiosErrorStore } from "@/stores/axiosErrorStore";
import { getDir } from "@utils";

export const Root = memo(function Root() {
  const { i18n } = useTranslation();
  const error = useAxiosErrorStore((state) => state.error);

  useEffect(() => {
    document.documentElement.dir = getDir(i18n.language);
    document.documentElement.lang = i18n.language;
  }, [i18n]);

  if (error) {
    throw new Response(error?.message || "", {
      status: error?.status,
    });
  }

  return (
    <React.StrictMode>
      <Outlet />
    </React.StrictMode>
  );
});
